"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElevenLabsClient = void 0;
const Client_1 = require("./api/resources/history/client/Client");
const Client_2 = require("./api/resources/textToSoundEffects/client/Client");
const Client_3 = require("./api/resources/audioIsolation/client/Client");
const Client_4 = require("./api/resources/samples/client/Client");
const Client_5 = require("./api/resources/textToSpeech/client/Client");
const Client_6 = require("./api/resources/speechToSpeech/client/Client");
const Client_7 = require("./api/resources/voiceGeneration/client/Client");
const Client_8 = require("./api/resources/textToVoice/client/Client");
const Client_9 = require("./api/resources/user/client/Client");
const Client_10 = require("./api/resources/voices/client/Client");
const Client_11 = require("./api/resources/projects/client/Client");
const Client_12 = require("./api/resources/chapters/client/Client");
const Client_13 = require("./api/resources/dubbing/client/Client");
const Client_14 = require("./api/resources/models/client/Client");
const Client_15 = require("./api/resources/audioNative/client/Client");
const Client_16 = require("./api/resources/usage/client/Client");
const Client_17 = require("./api/resources/pronunciationDictionary/client/Client");
const Client_18 = require("./api/resources/workspace/client/Client");
const Client_19 = require("./api/resources/speechToText/client/Client");
const Client_20 = require("./api/resources/conversationalAi/client/Client");
class ElevenLabsClient {
    constructor(_options = {}) {
        this._options = _options;
    }
    get history() {
        var _a;
        return ((_a = this._history) !== null && _a !== void 0 ? _a : (this._history = new Client_1.History(this._options)));
    }
    get textToSoundEffects() {
        var _a;
        return ((_a = this._textToSoundEffects) !== null && _a !== void 0 ? _a : (this._textToSoundEffects = new Client_2.TextToSoundEffects(this._options)));
    }
    get audioIsolation() {
        var _a;
        return ((_a = this._audioIsolation) !== null && _a !== void 0 ? _a : (this._audioIsolation = new Client_3.AudioIsolation(this._options)));
    }
    get samples() {
        var _a;
        return ((_a = this._samples) !== null && _a !== void 0 ? _a : (this._samples = new Client_4.Samples(this._options)));
    }
    get textToSpeech() {
        var _a;
        return ((_a = this._textToSpeech) !== null && _a !== void 0 ? _a : (this._textToSpeech = new Client_5.TextToSpeech(this._options)));
    }
    get speechToSpeech() {
        var _a;
        return ((_a = this._speechToSpeech) !== null && _a !== void 0 ? _a : (this._speechToSpeech = new Client_6.SpeechToSpeech(this._options)));
    }
    get voiceGeneration() {
        var _a;
        return ((_a = this._voiceGeneration) !== null && _a !== void 0 ? _a : (this._voiceGeneration = new Client_7.VoiceGeneration(this._options)));
    }
    get textToVoice() {
        var _a;
        return ((_a = this._textToVoice) !== null && _a !== void 0 ? _a : (this._textToVoice = new Client_8.TextToVoice(this._options)));
    }
    get user() {
        var _a;
        return ((_a = this._user) !== null && _a !== void 0 ? _a : (this._user = new Client_9.User(this._options)));
    }
    get voices() {
        var _a;
        return ((_a = this._voices) !== null && _a !== void 0 ? _a : (this._voices = new Client_10.Voices(this._options)));
    }
    get projects() {
        var _a;
        return ((_a = this._projects) !== null && _a !== void 0 ? _a : (this._projects = new Client_11.Projects(this._options)));
    }
    get chapters() {
        var _a;
        return ((_a = this._chapters) !== null && _a !== void 0 ? _a : (this._chapters = new Client_12.Chapters(this._options)));
    }
    get dubbing() {
        var _a;
        return ((_a = this._dubbing) !== null && _a !== void 0 ? _a : (this._dubbing = new Client_13.Dubbing(this._options)));
    }
    get models() {
        var _a;
        return ((_a = this._models) !== null && _a !== void 0 ? _a : (this._models = new Client_14.Models(this._options)));
    }
    get audioNative() {
        var _a;
        return ((_a = this._audioNative) !== null && _a !== void 0 ? _a : (this._audioNative = new Client_15.AudioNative(this._options)));
    }
    get usage() {
        var _a;
        return ((_a = this._usage) !== null && _a !== void 0 ? _a : (this._usage = new Client_16.Usage(this._options)));
    }
    get pronunciationDictionary() {
        var _a;
        return ((_a = this._pronunciationDictionary) !== null && _a !== void 0 ? _a : (this._pronunciationDictionary = new Client_17.PronunciationDictionary(this._options)));
    }
    get workspace() {
        var _a;
        return ((_a = this._workspace) !== null && _a !== void 0 ? _a : (this._workspace = new Client_18.Workspace(this._options)));
    }
    get speechToText() {
        var _a;
        return ((_a = this._speechToText) !== null && _a !== void 0 ? _a : (this._speechToText = new Client_19.SpeechToText(this._options)));
    }
    get conversationalAi() {
        var _a;
        return ((_a = this._conversationalAi) !== null && _a !== void 0 ? _a : (this._conversationalAi = new Client_20.ConversationalAi(this._options)));
    }
}
exports.ElevenLabsClient = ElevenLabsClient;
